import React from "react";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const SelectDropDown = ({options, dropdownLabel, value, setValue}) => {
//  console.log(value)
  console.log(options)
    return <>
        <TextField
          id={`outlined-select-${dropdownLabel}`}
          name={`${dropdownLabel.toLowerCase()}`}
          fullWidth
          required
          select
          label={dropdownLabel} 
          margin="normal"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        >
          {options?.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
    </>
}
export default SelectDropDown;